import { Component } from '@gondel/core';
import { GondelJqueryComponent } from '@gondel/plugin-jquery';
import addComponentAnimation from '@swisslife/shared-ui/src/utils/animations/js/animations';
import '../elements/distribution-teaser-item/js/distribution-teaser-item';

enum States {}

enum Selectors {}

// The @Component decorator will connect the class with `data-g-name="DistributionTeaser"` elements.
@Component('DistributionTeaser')
export class DistributionTeaser extends GondelJqueryComponent {
	private controllers: any[] = Array();
	private controllersTitle: any[] = Array();

	public async sync() {
		this.controllers = await addComponentAnimation(this.$ctx, '.js-m-distribution-teaser__item');
		this.controllersTitle = await addComponentAnimation(this.$ctx, '.js-m-distribution-teaser__title');
	}

	public stop() {
		for (const controller of this.controllers) {
			controller.destroy(true);
		}
		for (const controller of this.controllersTitle) {
			controller.destroy(true);
		}
	}
}
